// import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import Layout from "./components/AppSidebar";
// import Home from "./components/Home";
// import Dashboard from "./components/Dashboard";
// import Header from "./components/Header";
// import Categories from "./components/Categories";
// import SubCategories from "./components/SubCategories";
// import Banner from "./components/Banner";
// import Service from "./components/Service";
// import Booking from "./components/Booking";
// import User from "./components/User";
// import ServiceProvider from "./components/ServiceProvider";
// import Offers from "./components/Offers";
// import SubService from "./components/SubService.jsx";
// import Reviews from "./components/Reviews";
// import AppliedProvider from "./components/AppliedProvider";
// import AppliedProviderDetails from "./components/AppliedProviderDetails";
// import Sales from "./components/Sales";
// import RefundRequest from "./components/RefundRequest";
// import Product from "./components/Product";
// import Revenue from "./components/Revenue";
// import RegisterReport from "./components/RegisterReport";
// import ServiceProviderDetails from "./components/ServiceProviderDetails";
// import whatsapp from "./assets/icons8-whatsapp-480.png";
// import AllNotifications from "./components/AllNotifications";
// import CityList from "./components/CityList";
// import Notification from "./components/Notification";
// import Enquiry from "./components/Enquiry";
// import Login from "./components/login";
// import Subadmins from "./components/Subadmins";
// import PromotionalVideo from "./components/PromotionalVideo";
// import Orders from "./components/Orders";

// const isAuthenticated = true; // Change to false if not authenticated

// // Allowed routes for subadmin
// const allowedRoutes = [
//   "/", "/banners", "/categories", "subadmins" , "/sub_categories", "/service", "/subservice" ,
//    "/booking", "/user", "/verified_provider", "/applied_provider", "/applied_provider_details/:id",
//     "/offer", "/reviews", "/sales", "/refund_request", "/product", "/revenue", "/register_report", 
//     "/serviceProviderDetails/:id", "/enquiry", "/notification",
//     "/orders"
// ];

// function ProtectedRoute({ element, path }) {
//   // console.log("path : " , path , allowedRoutes.includes(path))
//   return element
//   return isAuthenticated && allowedRoutes.includes(path) ? element : <Navigate to="/login" />;
// }

// function App() {
//   return (
//     <>
//       <a href="https://web.whatsapp.com/">
//         <img src={whatsapp} alt="" className="bottom-4 right-0 w-10 fixed" />
//       </a>
//       <Notification />
//    <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/" element={<Layout />}>
//           <Route
//             index
//             element={<ProtectedRoute path="/" element={<><Header /><Dashboard /></>} />}
//           />
//           <Route
//             path="/banners"
//             element={<ProtectedRoute path="/banners" element={<><Header /><Banner /></>} />}
//           />
//           <Route
//             path="/promotionalvideo"
//             element={<ProtectedRoute path="/promotionalvideo" element={<><Header /><PromotionalVideo /></>} />}
//           />
//           <Route
//             path="/categories"
//             element={<ProtectedRoute path="/categories" element={<><Header /><Categories /></>} />}
//           />
//           <Route
//             path="/sub_categories"
//             element={<ProtectedRoute path="/sub_categories" element={<><Header /><SubCategories /></>} />}
//           />
//           <Route
//             path="/service"
//             element={<ProtectedRoute path="/service" element={<><Header /><Service /></>} />}
//           />
//           <Route
//             path="/subservice"
//             element={<ProtectedRoute path="/subservice" element={<><Header /><SubService /></>} />}
//           />
//           <Route
//             path="/booking"
//             element={<ProtectedRoute path="/booking" element={<><Header /><Booking /></>} />}
//           />
//           <Route
//             path="/orders"
//             element={<ProtectedRoute path="/orders" element={<><Header /><Orders /></>} />}
//           />
//           <Route
//             path="/user"
//             element={<ProtectedRoute path="/user" element={<><Header /><User /></>} />}
//           />
//           <Route
//             path="/verified_provider"
//             element={<ProtectedRoute path="/verified_provider" element={<><Header /><ServiceProvider /></>} />}
//           />
//           <Route
//             path="/applied_provider"
//             element={<ProtectedRoute path="/applied_provider" element={<><Header /><AppliedProvider /></>} />}
//           />
//           <Route
//             path="/applied_provider_details/:id"
//             element={<ProtectedRoute path="/applied_provider_details/:id" element={<><Header /><AppliedProviderDetails /></>} />}
//           />
//           <Route
//             path="/offer"
//             element={<ProtectedRoute path="/offer" element={<><Header /><Offers /></>} />}
//           />
//           <Route
//             path="/reviews"
//             element={<ProtectedRoute path="/reviews" element={<><Header /><Reviews /></>} />}
//           />
//           <Route
//             path="/sales"
//             element={<ProtectedRoute path="/sales" element={<><Header /><Sales /></>} />}
//           />
//           <Route
//             path="/refund_request"
//             element={<ProtectedRoute path="/refund_request" element={<><Header /><RefundRequest /></>} />}
//           />
//           <Route
//             path="/product"
//             element={<ProtectedRoute path="/product" element={<><Header /><Product /></>} />}
//           />
//           <Route
//             path="/revenue"
//             element={<ProtectedRoute path="/revenue" element={<><Header /><Revenue /></>} />}
//           />
//           <Route
//             path="/register_report"
//             element={<ProtectedRoute path="/register_report" element={<><Header /><RegisterReport /></>} />}
//           />
//           <Route
//             path="/serviceProviderDetails/:id"
//             element={<ProtectedRoute path="/serviceProviderDetails/:id" element={<><Header /><ServiceProviderDetails /></>} />}
//           />
//           <Route
//             path="/subadmins"
//             element={<ProtectedRoute path="/subadmins" element={<><Header /><Subadmins /></>} />}
//           />
//           <Route
//             path="/enquiry"
//             element={<ProtectedRoute path="/enquiry" element={<><Header /><Enquiry /></>} />}
//           />
//           <Route
//             path="/notification"
//             element={<ProtectedRoute path="/notification" element={<><Header /><AllNotifications /></>} />}
//           />
//         </Route>
//         </Routes>
//     </>
//   );
// }

// export default App;




































import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "./components/AppSidebar";
import Dashboard from "./components/Dashboard";
import Header from "./components/Header";
import Categories from "./components/Categories";
import SubCategories from "./components/SubCategories";
import Banner from "./components/Banner";
import Service from "./components/Service";
import Booking from "./components/Booking";
import User from "./components/User";
import ServiceProvider from "./components/ServiceProvider";
import Offers from "./components/Offers";
import SubService from "./components/SubService";
import Reviews from "./components/Reviews";
import AppliedProvider from "./components/AppliedProvider";
import AppliedProviderDetails from "./components/AppliedProviderDetails";
import Sales from "./components/Sales";
import RefundRequest from "./components/RefundRequest";
import Product from "./components/Product";
import Revenue from "./components/Revenue";
import RegisterReport from "./components/RegisterReport";
import ServiceProviderDetails from "./components/ServiceProviderDetails";
import AllNotifications from "./components/AllNotifications";
import Enquiry from "./components/Enquiry";
import Login from "./components/login";
import Subadmins from "./components/Subadmins";
import PromotionalVideo from "./components/PromotionalVideo";
import Orders from "./components/Orders";
import whatsapp from "./assets/icons8-whatsapp-480.png";
import ApiContext from "./context/AdminContext" 

const isAuthenticated = true; // Replace with actual authentication logic

// Allowed routes for subadmin
const allowedRoutes = [
  "/",
  "/banners",
  "/categories",
  "/subadmins",
  "/sub_categories",
  "/service",
  "/subservice",
  "/booking",
  "/user",
  "/verified_provider",
  "/applied_provider",
  "/applied_provider_details/:id",
  "/offer",
  "/reviews",
  "/sales",
  "/refund_request",
  "/product",
  "/revenue",
  "/register_report",
  "/serviceProviderDetails/:id",
  "/enquiry",
  "/notification",
  "/orders",
  "/promotionalvideo",
];

function ProtectedRoute({ element, path }) {
  // return isAuthenticated && allowedRoutes.includes(path) ? (
  return isAuthenticated  ? (
    element
  ) : (
    <Navigate to="/admin/login" />
  );
}

const AdminRoutes = () => {
  return (
    <>
      <a href="https://web.whatsapp.com/" className="fixed bottom-4 right-4">
        <img src={whatsapp} alt="WhatsApp" className="w-10" />
      </a>
      <ApiContext>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <ProtectedRoute
                path="/"
                element={
                  <>
                    <Header />
                    <Dashboard />
                  </>
                }
              />
            }
          />
          <Route
            path="banners"
            element={
              <ProtectedRoute
                path="/banners"
                element={
                  <>
                    <Header />
                    <Banner />
                  </>
                }
              />
            }
          />
          <Route
            path="promotionalvideo"
            element={
              <ProtectedRoute
                path="/promotionalvideo"
                element={
                  <>
                    <Header />
                    <PromotionalVideo />
                  </>
                }
              />
            }
          />
          <Route
            path="categories"
            element={
              <ProtectedRoute
                path="/categories"
                element={
                  <>
                    <Header />
                    <Categories />
                  </>
                }
              />
            }
          />
          <Route
            path="sub_categories"
            element={
              <ProtectedRoute
                path="/sub_categories"
                element={
                  <>
                    <Header />
                    <SubCategories />
                  </>
                }
              />
            }
          />
          <Route
            path="service"
            element={
              <ProtectedRoute
                path="/service"
                element={
                  <>
                    <Header />
                    <Service />
                  </>
                }
              />
            }
          />
          <Route
            path="subservice"
            element={
              <ProtectedRoute
                path="/subservice"
                element={
                  <>
                    <Header />
                    <SubService />
                  </>
                }
              />
            }
          />
          <Route
            path="booking"
            element={
              <ProtectedRoute
                path="/booking"
                element={
                  <>
                    <Header />
                    <Booking />
                  </>
                }
              />
            }
          />
          <Route
            path="orders"
            element={
              <ProtectedRoute
                path="/orders"
                element={
                  <>
                    <Header />
                    <Orders />
                  </>
                }
              />
            }
          />
          <Route
            path="user"
            element={
              <ProtectedRoute
                path="/user"
                element={
                  <>
                    <Header />
                    <User />
                  </>
                }
              />
            }
          />
          <Route
            path="verified_provider"
            element={
              <ProtectedRoute
                path="/verified_provider"
                element={
                  <>
                    <Header />
                    <ServiceProvider />
                  </>
                }
              />
            }
          />
          <Route
            path="applied_provider"
            element={
              <ProtectedRoute
                path="/applied_provider"
                element={
                  <>
                    <Header />
                    <AppliedProvider />
                  </>
                }
              />
            }
          />
          <Route
            path="applied_provider_details/:id"
            element={
              <ProtectedRoute
                path="/applied_provider_details/:id"
                element={
                  <>
                    <Header />
                    <AppliedProviderDetails />
                  </>
                }
              />
            }
          />
          <Route
            path="offer"
            element={
              <ProtectedRoute
                path="/offer"
                element={
                  <>
                    <Header />
                    <Offers />
                  </>
                }
              />
            }
          />
          <Route
            path="reviews"
            element={
              <ProtectedRoute
                path="/reviews"
                element={
                  <>
                    <Header />
                    <Reviews />
                  </>
                }
              />
            }
          />
          <Route
            path="sales"
            element={
              <ProtectedRoute
                path="/sales"
                element={
                  <>
                    <Header />
                    <Sales />
                  </>
                }
              />
            }
          />
          <Route
            path="refund_request"
            element={
              <ProtectedRoute
                path="/refund_request"
                element={
                  <>
                    <Header />
                    <RefundRequest />
                  </>
                }
              />
            }
          />
          <Route
            path="product"
            element={
              <ProtectedRoute
                path="/product"
                element={
                  <>
                    <Header />
                    <Product />
                  </>
                }
              />
            }
          />
          <Route
            path="revenue"
            element={
              <ProtectedRoute
                path="/revenue"
                element={
                  <>
                    <Header />
                    <Revenue />
                  </>
                }
              />
            }
          />
          <Route
            path="register_report"
            element={
              <ProtectedRoute
                path="/register_report"
                element={
                  <>
                    <Header />
                    <RegisterReport />
                  </>
                }
              />
            }
          />
          <Route
            path="serviceProviderDetails/:id"
            element={
              <ProtectedRoute
                path="/serviceProviderlrtDetails/:id"
                element={
                  <>
                    <Header />
                    <ServiceProviderDetails />
                  </>
                }
              />
            }
          />
          <Route
            path="subadmins"
            element={
              <ProtectedRoute
                path="/subadmins"
                element={
                  <>
                    <Header />
                    <Subadmins />
                  </>
                }
              />
            }
          />
          <Route
            path="enquiry"
            element={
              <ProtectedRoute
                path="/enquiry"
                element={
                  <>
                    <Header />
                    <Enquiry />
                  </>
                }
              />
            }
          />
          <Route
            path="enquiry"
            element={
              <ProtectedRoute
                path="/sales"
                element={
                  <>
                    <Header />
                    <Sales/>
                  </>
                }
              />
            }
          />
          <Route
            path="notification"
            element={
              <ProtectedRoute
                path="/notification"
                element={
                  <>
                    <Header />
                    <AllNotifications />
                  </>
                }
              />
            }
          />
        </Route>
      </Routes>
      </ApiContext>
    </>
  );
};

export default AdminRoutes;